import React from 'react';
import {
    View,
    colors,
    Page,
    Grid,
    GridColumn,
    Link,
    Heading,
} from '@fairygodboss/ui';
import { ContentCard } from './components/ContentCard';
import { useCommunityContent } from '../CommunityPostContentContext';
import {
    decodeRawHtmlText,
    decodeRawHtml,
} from '../../../../../utilities/helperFunctions';
import { getTitle } from '../../../../../utilities/ui_utilities';



export const RecentPosts = () => {
    const { hash, recentContent, seeMoreLink } = useCommunityContent();

    const posts = recentContent
        .filter((post) => {
            if (post.hash === hash) return false;
            if (post?.type === 'community-discussion') {
                const info = decodeRawHtmlText(post?.rawHtml);
                return info.realLength > 0;
            }
            if (post?.type === 'community-link') {
                const info = getTitle(post?.description);
                const info2 = decodeRawHtmlText(post?.rawHtml);
                return info.realLength > 0 && info2.realLength >0;
            }
            const info = decodeRawHtml(post?.description);
            return info.body !== '';
        })
        .slice(0, 6);



    return (

        <View
            display="flex"
            width="100%"
            css={{
                fontFamily: 'Open Sans',
                color: colors.neutral[100],
                'a:visited': {
                    color: `${colors.primary[60]} !important`,
                    'div > svg': {
                        path: {
                            fill: colors.primary[60],
                        },
                    },
                    'a:hover': {
                        'div > svg': {
                            path: {
                                fill: colors.primary[80],
                            },
                        },
                    },
                },
                a: {
                    textDecoration: 'none',
                    fontSize: '16px',
                    lineHeight: '20px',
                    fontWeight: '600',
                },
            }}
            backgroundColor="#F0F2F5"
        >
            <View
                display="flex"
                width="100%"
                flexDirection="column"
                alignItems="center"
            >
                <Page width="100%">
                    <Grid
                        maxWidth="1176px"
                        pl={{ _: '16px', sm: '8px', md: '12px', lg: '12px' }}
                        pr={{ _: '16px', sm: '8px', md: '12px', lg: '12px' }}
                        justifyContent={{
                            _: 'left',
                            sm: 'center',
                            md: 'left',
                            lg: 'right',
                        }}
                    >
                        <GridColumn
                            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                            pl="100px"
                            backgroundColor="red"
                            css={{
                                paddingLeft: '0px',
                                paddingRight: '0px',
                                position: 'relative',
                            }}
                        >
                            <Heading
                                pt={{
                                    _: '40px',
                                    sm: '32px',
                                    md: '48px',
                                    lg: '56px',
                                }}
                                variant={{ _: 'headingSm', sm: 'headingLg' }}
                                fontWeight="700"
                                css={{
                                    h2: {
                                        fontWeight: '700',
                                    },
                                }}
                                mb={{ _: '8px', sm: '-8px', md: '0px' }}
                                pl={{ _: '0px', sm: '8px', md: '12px' }}
                            >
                                <h2> Browse recent posts </h2>
                            </Heading>
                            <View display="flex" flexWrap="wrap">
                                {posts.length
                                    ? posts.map((i) => {
                                          return (
                                              <ContentCard
                                                  hash={i?.hash}
                                                  key={i?.hash}
                                                  type={i?.type}
                                                  article={i}
                                                  url={i?.contentUrl}
                                              />
                                          );
                                      })
                                    : null}
                            </View>
                            <View
                                display="-webkit-box"
                                justifyContent="end"
                                py="48px"
                                pr={{ _: '0px', sm: '8px', md: '12px' }}
                            >
                                <Link
                                    href={seeMoreLink}
                                    target="_self"
                                    icon
                                    variant="standalone"
                                >
                                    See more
                                </Link>
                            </View>
                        </GridColumn>
                    </Grid>
                </Page>
            </View>
        </View>
    );
};
